import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LandingComponent } from './home/landing.component';
import { AppUnavailableComponent } from './core/app-unavailable';
import { LoginComponent } from './auth/login.component';
import { LoginFailedComponent } from './auth/login-failed.component';
import { LogoutComponent } from './auth/logout.component';
import { systemReadyGuard } from './shared/system-ready.guard';
import { HomeComponent } from './home/home.component';
import { UnauthorizedComponent } from './core/unauthourised';
import { roleGuard } from './shared/authz/role-guard';
import { ROLE_GROUPS } from './shared/authz/role-groups';

export const routes: Routes = [
  {
    path: 'approve',
    // Reached straight from the orders grid — see OptInIdlePreloadStrategy for what `preload` does.
    data: { preload: true },
    loadChildren: () => import('./orders/approve/approve.routes').then((m) => m.APPROVE_ROUTES)
  },
  {
    path: 'brokers',
    loadChildren: () => import('./counterparty-data/brokers/broker.routes').then((m) => m.BROKERS_ROUTES)
  },
  {
    path: 'fiduciaries',
    loadChildren: () => import('./counterparty-data/fiduciaries/fiduciaries.routes').then((m) => m.FIDUCIARIES_ROUTES)
  },
  /*{
    path: 'pk-mappings',
    children: [
      { path: 'create', component: CreateProductKnowledgeMappingComponent, canActivate: [MsalGuard, roleGuard(ROLE_GROUPS.pkMappingWrite)] },
      { path: ':id/edit', component: EditProductKnowledgeMappingComponent, canActivate: [MsalGuard, roleGuard(ROLE_GROUPS.pkMappingWrite)] },
      { path: '', pathMatch: 'full', component: ProductKnowledgeMappingComponent, canActivate: [MsalGuard, roleGuard(ROLE_GROUPS.pkMappingView)] }
    ]
  },*/
  {
    path: 'check',
    data: { preload: true },
    loadChildren: () => import('./orders/check/check.routes').then((m) => m.CHECK_ROUTES)
  },
  {
    path: 'custodians',
    loadChildren: () => import('./counterparty-data/custodians/custodians.routes').then((m) => m.CUSTODIANS_ROUTES)
  },
  {
    path: 'portfolios',
    loadChildren: () => import('./counterparty-data/portfolios/portfolios.routes').then((m) => m.PORTFOLIOS_ROUTES)
  },
  {
    path: 'securities',
    loadChildren: () => import('./counterparty-data/securities/securities.routes').then((m) => m.SECURITIES_ROUTES)
  },
  {
    path: 'td-rates',
    loadChildren: () => import('./counterparty-data/td-rates/td-rates.routes').then((m) => m.TD_RATES_ROUTES)
  },
  { path: 'home', component: HomeComponent, canActivate: [MsalGuard, systemReadyGuard] },
  {
    path: 'dashboard',
    loadComponent: () => import('./home/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [MsalGuard, systemReadyGuard]
  },
  { path: 'login', component: LoginComponent },
  { path: 'login-failed', component: LoginFailedComponent },
  { path: 'logout', component: LogoutComponent },
  {
    path: 'orders',
    canActivate: [MsalGuard],
    // The app's hub: HomeComponent redirects here for everyone except partial-executions-only users.
    data: { preload: true },
    loadChildren: () => import('./orders/orders.routes').then((m) => m.ORDERS_ROUTES)
  },
  {
    path: 'partial-executions',
    // Lazy, not `component:` — a static import here put this screen's GridModule /
    // DateRangePickerModule / Excel-export imports in the initial bundle for every user.
    loadComponent: () =>
      import('./orders/partial-executions/partial-executions.component').then((m) => m.PartialExecutionsComponent),
    canActivate: [MsalGuard, roleGuard(ROLE_GROUPS.partialExecutionsView)]
  },
  {
    path: 'fees',
    loadChildren: () => import('./counterparty-data/fees/fees.routes').then((m) => m.FEES_ROUTES)
  },
  {
    // The Time Deposits blotter is an order view — it loads TD orders and offers row actions on
    // them — so it gates like one. It was previously reachable by any authenticated user, including
    // partial-executions-only users, and ran without waiting for the securities/portfolio caches.
    path: 'time-deposits',
    canActivate: [MsalGuard, roleGuard(ROLE_GROUPS.orderReadWrite), systemReadyGuard],
    loadComponent: () => import('./orders/time-deposits/time-deposits.component').then((m) => m.TimeDepositsComponent)
  },
  {
    path: 'trade-restrictions',
    loadChildren: () =>
      import('./compliance/trade-restrictions/trade-restrictions.routes').then((m) => m.TRADE_RESTRICTIONS_ROUTES)
  },
  {
    path: 'pre-trade-check',
    loadChildren: () => import('./compliance/pre-trade-check/pre-trade-check.routes').then((m) => m.PRETRADECHECKROUTES)
  },
  { path: 'unavailable', component: AppUnavailableComponent },
  { path: '', pathMatch: 'full', component: LandingComponent },
  { path: 'unauthorized', component: UnauthorizedComponent }
];
